var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "x_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "x_svg__Platform=X, x_svg__Coloured=No, x_svg__State=Default",
    clipPath: "url(#x_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.943 10.162 22.665 0h-2.067l-7.573 8.824L6.976 0H0l9.147 13.343L0 24h2.067l7.997-9.318L16.452 24h6.977zm-2.83 3.299-.928-1.329L2.812 1.56h3.174l5.951 8.532.927 1.329 7.735 11.09h-3.175l-6.312-9.05Z",
    className: "x_svg__Vector"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x_svg__a",
    className: "x_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5YPC90aXRsZT48ZyBjbGFzcz0iUGxhdGZvcm09WCwgQ29sb3VyZWQ9Tm8sIFN0YXRlPURlZmF1bHQiIGNsaXAtcGF0aD0idXJsKCNhKSI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTMuOTQzIDEwLjE2MiAyMi42NjUgMGgtMi4wNjdsLTcuNTczIDguODI0TDYuOTc2IDBIMGw5LjE0NyAxMy4zNDNMMCAyNGgyLjA2N2w3Ljk5Ny05LjMxOEwxNi40NTIgMjRoNi45NzdsLTkuNDg2LTEzLjgzOFptLTIuODMgMy4yOTktLjkyOC0xLjMyOUwyLjgxMiAxLjU2aDMuMTc0bDUuOTUxIDguNTMyLjkyNyAxLjMyOSA3LjczNSAxMS4wOWgtMy4xNzVsLTYuMzEyLTkuMDVaIiBjbGFzcz0iVmVjdG9yIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSIgY2xhc3M9ImEiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTAgMGgyNHYyNEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";